import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Camera, ArrowUpRight } from "lucide-react";
import Reveal from "@/components/Reveal";

const SHOTS = [
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_0d237708-2939-4749-85f1-51c7a8f51e7c/artifacts/opj4qdfk_IMG_9207.jpeg",
    tag: "Renovation",
    caption: "Bathroom pendant lighting — warm, deliberate, finished.",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_0d237708-2939-4749-85f1-51c7a8f51e7c/artifacts/fq44njus_IMG_9206.jpeg",
    tag: "New Build Tech",
    caption: "Starlink roof mount — clean entry, weather sealed.",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_0d237708-2939-4749-85f1-51c7a8f51e7c/artifacts/a44ovcxb_IMG_9227.jpeg",
    tag: "New Build",
    caption: "Switchboard fit-off — roughed in, mounted, ready for fit-out.",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_0d237708-2939-4749-85f1-51c7a8f51e7c/artifacts/oblhvske_IMG_9208.jpeg",
    tag: "Finish Work",
    caption: "PowerPoint install — flush, level, tested.",
  },
];

const Showcase = () => (
  <section id="work" className="border-t border-ink/10 bg-[#f7f8f6] py-16 md:py-28" data-testid="showcase-section">
    <div className="mx-auto max-w-7xl px-5 md:px-10">
      <Reveal className="flex flex-wrap items-end justify-between gap-6">
        <div>
          <p className="mb-3 flex items-center gap-2 text-xs uppercase tracking-[0.3em] text-petrol md:text-sm">
            <Camera className="h-3.5 w-3.5" strokeWidth={1.75} />
            02 — Gallery
          </p>
          <h2 className="font-display text-4xl font-black uppercase tracking-tight text-petrol md:text-6xl">
            Our work
          </h2>
        </div>
        <p className="max-w-xs text-sm leading-relaxed text-ink/60">
          Real jobs, straight from the field — renos, new builds and finish work.
          More photos added as the work keeps coming.
        </p>
      </Reveal>
      <div className="mt-10 grid grid-cols-2 gap-3 md:mt-16 md:gap-6">
        {SHOTS.map((shot, i) => (
          <motion.figure
            key={shot.tag}
            initial={{ opacity: 0, y: 28 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.7, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] }}
            className="group"
            data-testid={`showcase-item-${i}`}
          >
            <div className="relative overflow-hidden border-2 border-ink bg-white transition-all duration-300 group-hover:border-copper group-hover:shadow-[6px_6px_0_#c8925a]">
              <img
                src={shot.src}
                alt={shot.caption}
                className="h-40 w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105 sm:h-48 md:h-72 lg:h-[26rem]"
              />
              <span className="absolute left-2 top-2 bg-petrol/90 px-2 py-0.5 text-[9px] uppercase tracking-[0.2em] text-white md:left-3 md:top-3 md:text-[10px]">
                {shot.tag}
              </span>
            </div>
            <figcaption className="mt-2 text-[11px] leading-snug text-ink/60 md:mt-3 md:text-sm">
              {shot.caption}
            </figcaption>
          </motion.figure>
        ))}
      </div>
      <Reveal className="mt-10 text-center md:mt-14">
        <p className="hidden text-xs uppercase tracking-[0.3em] text-ink md:block">
          Like what you see? This could be your place.
        </p>
        <Link
          to="/quote"
          data-testid="gallery-quote-button"
          className="group mt-5 inline-flex items-center gap-2 bg-petrol px-8 py-4 text-sm font-bold uppercase tracking-[0.15em] text-white transition-colors hover:bg-copper hover:text-ink"
        >
          Get a Free Quote
          <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" strokeWidth={2} />
        </Link>
      </Reveal>
    </div>
  </section>
);

export default Showcase;
